export const DocumentEN = {

    DGDocument: {
        heading: {
            rename: "Rename",
            create: "Create Document",
            personal: "Personal Document",
            attach: "Attached Document",
            company: {
                all: "Company Document",
            },
            move: "Move"
        },
        label: {
            name: "Name",
            creator: "Creator",
            type: "Type",
            size: "Size",
            modifiedDate: "Modified Date",
            sharedObjects: "Shared Objects",
            module: {
                type: "Type"
            },
            object: "Object",
            isEdit: "Edit",
            projectObject: "Phase and Task",
            createDate: "Create Date"
        },
        placeholder: {
            search: "Search",
            folder: "Name"
        },
        description: {
            drag: {
                title: "Click or drag file to this area to upload",
                hint: "Support for a single file or bulk upload files."
            }
        },
        action: {
            clone: "Clone",
            move: "Move",
            add: {
                folder: "Create folder",
                file: "Upload File"
            },
            upload: {
                folder: "Upload Folder"
            },
            update: {
                true: "Public",
                false: "Private"
            },
            favorite: {
                love: "Favorite",
                inLove: "UnFavorite"
            },
            rename: "Rename",
            delete: "Delete",
            download: "Download",
            preview: "Open",
            back: "Back",
            view: {
                list: "List View",
                grid: "Grid View"
            },
            cancel: "cancel",
            detail: "Detail",
            open: "Open"
        },
        button: {
            update: "Rename",
            create: "Create",
            cancel: "Cancel"
        },
        text: {
            to: "to"
        },
        message: {
            success: {
                download: "Download Success",
                move: "Move Success"
            },
            validator: {
                file: {
                    size: "is larger than 10MB",
                    is: "not is file"
                },
                folder: "Don't upload empty folder"
            },
            warning: {
                delete: "Are you delete file?"
            }
        },
        value: {
            time: {
                year: "year ago",
                month: "month  ago",
                day: "day ago",
                hour: "hour ago",
                minute: "minute ago",
                second: "second ago"
            },
            isEdit: {
                yes: "Yes"
            }
        },
        modules: {
            PERSONNEL: "Personnel",
            APPLICATION: "Application",
            WORK: "Work",
            DECISION: "Decision"
        },
        apps: {
            PERSONNEL: {
                RECORD: "Personnel Record",
                LABEL_CONTRACT: "Labor Contract",
                DECISION: "Decision"
            },
            APPLICATION: {
                CHECK_IN_OUT: "Checkin/checkout application",
                ABSENCE: "Absence application",
                RESIGN: "Resign application",
                SHIFT_SWAP: "Shift swap application",
                MISSION: "Mission application",
                OVERTIME: "Overtime application",
                SHIFT_MORE: "Shift more application",
                FLEXIBLE: "Flexible application",
                LEAVE: "Leave application",
                SHIFT_REGISTRATION: "Shift registration application",
                LATE_EARLY: "Late/early application"
            },
            WORK: {
                NORMAL: "Task",
                PROJECT: "Project",
                PROCESS: "Work process",
                PHASE: "Phase",
                SEQUENCE: "sequence"
            },
            DECISION: {
                SALARY: "Salary Decision",
                DISMISSAL: "Dismissal Decision",
                DISCIPLINE: "Discipline Decision",
                REWARD: "Reward Decision",
                TRANSFER: "Transfer Decision",
                APPOINTMENT: "Appointment Decision",
                ADMISSION: "Admission Decision",
                CONTRACT: "Contract Decision"
            }
        }
    }
}